import styled from 'styled-components';

import { GridContainer } from '@xing-com/grid';

export const Container = styled(GridContainer)`
  gap: 0;
`;
